import { actions } from './actions'

const initialState = {
  fechasBloqueadas: {
    data: [],
    loading: false,
    error: '',
  },
  fechaBloqueada: {
    data: null,
    loading: false,
    error: '',
  },
  fechasBloqueadasProvincia: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function fechaBloqueadaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FECHA_BLOQUEADA_LOAD_REQUESTED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: true },
      }
    case actions.FECHA_BLOQUEADA_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, data: action.payload, loading: false },
      }
    case actions.FECHA_BLOQUEADA_LOAD_FILED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: false, error: action.error },
      }
    case actions.FECHA_BLOQUEADA_BY_ID_LOAD_REQUESTED:
      return {
        ...state,
        fechaBloqueada: { ...state.fechaBloqueada, loading: true },
      }
    case actions.FECHA_BLOQUEADA_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        fechaBloqueada: { ...state.fechaBloqueada, data: action.payload, loading: false },
      }
    case actions.FECHA_BLOQUEADA_BY_ID_LOAD_FILED:
      return {
        ...state,
        fechaBloqueada: { ...state.fechaBloqueada, loading: false, error: action.error },
      }

    case actions.FECHA_BLOQUEADA_INSERT_REQUESTED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: true, error: '' },
      }
    case actions.FECHA_BLOQUEADA_INSERT_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadas: {
          ...state.fechasBloqueadas,
          data: [].concat(action.payload, state.fechasBloqueadas.data),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_BLOQUEADA_INSERT_FILED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: false, error: action.error },
      }

    case actions.FECHA_BLOQUEADA_UPDATE_REQUESTED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: true, error: '' },
      }
    case actions.FECHA_BLOQUEADA_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadas: {
          ...state.fechasBloqueadas,
          data: state.fechasBloqueadas.data.map(fecha =>
            fecha.id === action.payload.id ? action.payload : fecha,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_BLOQUEADA_UPDATE_FILED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: false, error: action.error },
      }

    case actions.FECHA_BLOQUEADA_DELETE_REQUESTED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: true, error: '' },
      }
    case actions.FECHA_BLOQUEADA_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadas: {
          ...state.fechasBloqueadas,
          data: state.fechasBloqueadas.data.filter(fecha => fecha.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_BLOQUEADA_DELETE_FILED:
      return {
        ...state,
        fechasBloqueadas: { ...state.fechasBloqueadas, loading: false, error: action.error },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_REQUESTED:
      return {
        ...state,
        fechasBloqueadasProvincia: { ...state.fechasBloqueadasProvincia, loading: true },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadasProvincia: {
          ...state.fechasBloqueadasProvincia,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_FILED:
      return {
        ...state,
        fechasBloqueadasProvincia: {
          ...state.fechasBloqueadasProvincia,
          loading: false,
          error: action.error,
        },
      }

    case actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_REQUESTED:
      return {
        ...state,
        fechasBloqueadasProvincia: { ...state.fechasBloqueadasProvincia, loading: true, error: '' },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadasProvincia: {
          ...state.fechasBloqueadasProvincia,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_FILED:
      return {
        ...state,
        fechasBloqueadasProvincia: {
          ...state.fechasBloqueadasProvincia,
          loading: false,
          error: action.error,
        },
      }

    case actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_REQUESTED:
      return {
        ...state,
        fechasBloqueadasProvincia: { ...state.fechasBloqueadasProvincia, loading: true, error: '' },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasBloqueadasProvincia: {
          ...state.fechasBloqueadasProvincia,
          data: [],
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_FILED:
      return {
        ...state,
        fechasBloqueadasProvincia: {
          ...state.fechasBloqueadasProvincia,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
